import { ToastContainer } from 'react-toastify';

import WebinarForm from '../WebinarForm';

import { isWebView } from '@src/helpers';

import '../styles.scss';

const UpdateWebinar = () => {
  return (
    <div className="webinar-container">
      {!isWebView() && <h4>Update a webinar meeting</h4>}
      <WebinarForm submitLabel="Update" />
      <ToastContainer />
    </div>
  );
};

export default UpdateWebinar;
